/**
 * Workspace — the public card's read seam: workspaces/{orgId}, live, parsed,
 * or null where no such organization exists.
 */
import { snapshotDoc$ } from "@mhmo91/rx";
import { Workspace } from "@momo/types";
import { doc, type Firestore } from "firebase/firestore";
import { map, type Observable } from "rxjs";

export function workspaceCard$(
	db: Firestore,
	orgId: string,
): Observable<Workspace.Workspace | null> {
	return snapshotDoc$(doc(db, "workspaces", orgId)).pipe(
		map((snap) =>
			snap.exists() ? Workspace.WorkspaceSchema.parse(snap.data()) : null,
		),
	);
}
